import { laptopMediumMax, mobileXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import { Content } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import styled from 'styled-components';

export const Container = styled.section`
  position: relative;
  padding: 100px 0 70px 0;
  background-color: #f9d8cd;
`;

export const Wrapper = styled(PageWrapper)`
  position: relative;
  ${Content} {
    max-width: 1280px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const TextContent = styled.section`
  ${SubHeading} {
    max-width: 950px;
    margin: 0 auto 45px;
    line-height: 1.15;

    span {
      color: ${({ theme }) => theme.primary};
    }

    @media (${laptopMediumMax}) {
      font-size: 35px;
    }

    @media (${mobileXLargeMax}) {
      font-size: 30px;
    }
  }

  ${Text} {
    line-height: 1.5;
    color: #333;
    max-width: 880px;
    margin: 0 auto;

    @media (${mobileXLargeMax}) {
      font-size: 18px;
    }
  }
`;

export const LogoGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  width: 100%;
  margin: 70px auto;
  max-width: 990px;

  @media (max-width: 1200px) {
    max-width: 900px;
  }
`;

export const LogoGridItem = styled.a<{ bgColour?: string }>`
  background: ${({ theme, bgColour }) => bgColour || theme.white};
  width: 225px;
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  overflow: hidden;
`;

export const AgentLogo = styled.img<{ bg?: string }>`
  background: ${({ theme, bg }) => bg || theme.white};
  max-width: 162px;
  max-height: 55px;
`;
